export default class ConfigModel {
  constructor(attrs = {}) {
    Object.assign(this, attrs);
  }
  get(k) {
    return this[k];
  }
  /**
   *  returns the maps api host, removing user template
   *  and the protocol.
   *  carto.com:3333
   */
  getMapsApiHost() {
    var url;
    var mapsApiTemplate = this.get("maps_api_template");
    if (mapsApiTemplate) {
      url = mapsApiTemplate.replace(/https?:\/\/{user}\./, "");
    }
    return url;
  }

  setUrlVersion(modelName, method, v) {
    this.set(modelName + "_" + method + "_url_version", v || "v1");
  }

  urlVersion(modelName, method, defaultVersion) {
    method = method || "";
    var version = this.get(modelName + "_" + method + "_url_version");
    return version || defaultVersion || "v1";
  }

  prefixUrl() {
    return this.get("url_prefix") || "";
  }

  prefixUrlPathname() {
    var prefix = this.prefixUrl();
    if (prefix !== "") {
      try {
        if (prefix && prefix.indexOf("/") === -1)
          throw new TypeError("invalid URL");
        var a = document.createElement("a");
        a.href = prefix;
        var url = a.pathname;
        // remove trailing slash
        return url.replace(/\/$/, "");
      } catch (e) {
        // not an url
      }
    }
    return prefix;
  }

  getMapsResourceName(username) {
    var url;
    var mapsApiTemplate = this.get("maps_api_template");
    if (mapsApiTemplate) {
      url = mapsApiTemplate
        .replace(/{user}/g, username);
    }
    return url;
  }
}
